import React, { Component } from 'react'
import "./AboutUs.scss"
import { Icon } from "semantic-ui-react";


export default class AboutUs extends Component {
    render() {
        return (
            <div id="AboutUs">
                
                <div className="row">
                <div className="col-md-12">
                    <h2><strong>Qui suis-je ?</strong></h2>
                    <img src="https://image.noelshack.com/fichiers/2019/39/1/1569246668-img-1476-2.jpeg" height="200px" alt=""/>

                    <p>Dans le cadre de ma formation de développeur web et application mobile , je recherche un poste de stagiaire développeur pour une durée de 2 mois.
 
 Le but de ce stage en entreprise est de consolider mes connaissances et mon savoir-faire tout en m'imprégnant du contexte du monde professionnel et de ses contraintes en termes de délais. Fort des connaissances théoriques acquises depuis le début de ma formation, je possède d'ores et déjà une bonne maîtrise des langages de programmation et des lignes de codes informatiques. 
 
 Volontaire, ayant le goût de l'initiative et du challenge, j'aime travailler en équipe.
                    </p>
                    <button>
            <a href="https://drive.google.com/file/d/171mNuWAA2zv77Y8tt3AqOlS993yidmRc/view">Télécharger mon CV<Icon className="download pl-2"></Icon></a>
          </button>
                    </div>
                </div>
            </div>
        )
    }
}




